import { IconButton, Stack, Typography } from '@mui/material';
import Docker from '../icon/Docker';
import UserIcon from '../icon/CircleUser';
import GithubIcon from '../icon/Github';
import LinkedinIcon from '../icon/Linkedin';

export default function Footbat() {
  return (
    <Stack spacing={2}>
      <Stack spacing={2} justifyContent="center" direction="row" sx={{mt:'1em !important'}}>
          <Typography variant="overline" sx={{ mt: "0em !important" }} color="text.secondary">NoteBook</Typography>
      </Stack>
      <Stack spacing={2} justifyContent="center" direction="row" sx={{mt: '0em !important'}}>
          <Typography variant="overline" component={"a"} target="_blank" href="https://devtul.firebaseapp.com/home">Json Editor</Typography>
          <Typography variant="overline" component={"a"} target="_blank" href="https://gemtul.firebaseapp.com/home.html">Badam Satti</Typography>
          <Typography variant="overline" component={"a"} target="_blank" href="https://uzrnem.github.io/">Brick Games</Typography>
          <Typography variant="overline" component={"a"} target="_blank" href="https://uzrnem.github.io/pushbox.html">Pushbox</Typography>
      </Stack>
      <Stack spacing={2} justifyContent="center" direction="row" sx={{mt:'0em !important'}}>
          <IconButton component={"a"} target="_blank" href="https://github.com/uzrnem">
            <GithubIcon />
          </IconButton>
          <IconButton component={"a"} target="_blank" href="https://www.linkedin.com/in/uzrnem">
            <LinkedinIcon />
          </IconButton>
          <IconButton component={"a"} target="_blank" href="https://devtul.firebaseapp.com/about.html">
            <UserIcon />
          </IconButton>
          <IconButton component={"a"} target="_blank" href="https://hub.docker.com/u/uzrnem">
            <Docker />
          </IconButton>
      </Stack>
    </Stack>
  );
}